import React, { useState } from 'react';
import Modal from 'components/new_ui/Modal/Modal';

import { Button } from 'react-bootstrap5';

import actions from './Actions';

export default function Index() {
  const [show, setShow] = useState(true);
  const [openVideo, setOpenVideo] = useState(false);

  const closeForm = () => setShow(false);

  const closeRequiredAction = (callback) => {
    actions.skip('return_to_work_first_ai_session', () => {
      closeForm();
      callback();
    });
  };

  const onSkipClick = () => {
    closeRequiredAction(() => {});
  };

  const onStartClick = () => {
    closeRequiredAction(() => {
      setOpenVideo(true);
    });
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={closeForm}
      onExited={() => {
        if (openVideo) {
          setTimeout(() => {
            const event = new CustomEvent('ReturnToWorkFirstAiSession', {
              detail: {
                // welcomeMessage: `Hi <name>, welcome to your Health and Performance Assessment debrief.
                // I’m here to help you understand your results and develop an action plan.
                // Ready to explore your assessment insights?`,
                welcomeMessage: `Please introduce yourself as my Health and Performance Coach. 
                Then review my Health and Performance Assessment results and provide a brief, 
                motivational introduction. Highlight my key strengths and growth areas using 
                percentile scores in a conversational way. 
                Make connections between different dimensions and suggest one area where I 
                could focus my development efforts. Use an encouraging tone and coaching style.`,
                isReturnToWorkFirstAiSession: true,
              },
            });
            window.dispatchEvent(event);
          }, 1000);
        }
      }}
    >
      <h2>AI Coach Debrief</h2>

      <h3>Your Personalized Work Readiness Guidance</h3>
      <p>
        The AI Coach Debrief is designed to provide you with tailored
        insights based on your Health and Performance Assessment results.
        During this interactive session, you&apos;ll:
      </p>
      <ul>
        <li>Review your assessment findings with AI-driven analysis</li>
        <li>Identify specific challenges in your return-to-work journey</li>
        <li>Develop practical strategies for workplace reintegration</li>
        <li>Create an actionable plan with clear milestones</li>
        <li>Receive personalized resources matched to your needs</li>
      </ul>
      <h3>What to Expect</h3>
      <p>
        Our AI Coach uses advanced conversational intelligence to provide
        personalized guidance while maintaining complete confidentiality.
        Come prepared to discuss your concerns and goals for returning to work.
      </p>

      <footer className="d-flex justify-content-between">
        <Button
          onClick={onSkipClick}
          variant="link"
        >
          Skip
        </Button>
        <Button onClick={onStartClick}>
          Start Now
        </Button>
      </footer>
    </Modal>
  );
}
